import React from 'react';
import PropTypes from 'prop-types';

import { 
  Grid,
  IconButton,
  TableCell,
  TextField,
  Tooltip,
  Typography,
}                               from '@material-ui/core';

import { makeStyles }           from '@material-ui/core/styles';

import {
  Done as DoneIcon,
  Error as ErrorIcon,
  Input as InputIcon,
  SkipNext as SkipNextIcon,
}                               from '@material-ui/icons';

import { 
  Autocomplete,
}                               from '@material-ui/lab';

import { 
  ExecutionDataTable,
  useExecutions,
}                               from '../../..';

import { 
  fmtExecutionEndTime 
}                               from '../../../formatters';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: "100%",
    },
    marginRight: theme.spacing(1),
  },
  grid: {
    flexGrow: 1,
  },
}));

function getIncludeResult(selectors, includeResultDefaults) {
  let includeResult=null;
  if(selectors) {
    if(Array.isArray(selectors) && selectors.length>0) {
      includeResult=selectors[0].IncludeResult;
    } 
  }
  return includeResult || includeResultDefaults;
}

export default function ChooseDataByExecutionStep(props) {
  const {
    workloadId,
    inputSelectors,
    onInputSelectorsChange,
  } = props;
  
  const classes = useStyles();
  const includeResultDefaults=['FAILED'];

  const { executions } = useExecutions({
    workloadId: workloadId, //status: 'COMPLETE'
  });
  
  const handleSelectedExecutionsChange = (executions) => {
    // console.log("handleSelectedExecutionsChange: ",executions)
    const includeResult=getIncludeResult(inputSelectors,includeResultDefaults); 
    const selectors=executions.map(e=> {
      const selector={
        Execution: e.ExecutionId,
      };
      if(includeResult.length>1) {
        selector['IncludeResult']=includeResult;
      } else if(includeResult.length===1) {
        selector['IncludeResult']=includeResult[0];
      }
      return selector;
    }); 
    handleInputSelectorsChange(selectors);
  };
  
  const handleIncludeResultChange = (event, includeResult) => {
    // console.log("includeResult: ",includeResult)
    const selectors=inputSelectors.map(s => {
      if(!includeResult.length) {
        if(s.hasOwnProperty('IncludeResult')) {
          delete s.IncludeResult;
        }
      } else {
        s['IncludeResult']=includeResult.length===1?includeResult[0]:includeResult;
      }
      return s;
    });
    handleInputSelectorsChange(selectors);
  };
  
  const handleInputSelectorsChange = (selectors) => {
    if(onInputSelectorsChange) {
      onInputSelectorsChange(selectors);
    }
  };
  
  const inputResultIcon = (label) => {
    if(typeof label==='string') {
      const value=label.toLowerCase();    
      if(value==='submitted') return <InputIcon color="primary"/>;
      else if(value==='skipped') return <SkipNextIcon style={{fill: "orange"}}/>;
      else if(value==='failed') return <ErrorIcon color="error"/>;
      else if(value==='succeeded') return <DoneIcon style={{ fill: "green"}}/>;
      else return label;
    } else {
      return "";
    }
  };
  
  const inputObjectsHeadRender = ({index, ...column}, updateDirection) => {
    return(
      <TableCell key={index} align="right" style={{ paddingRight: '16px'}} >
        <Tooltip placement="top" title={column.label}>
          <IconButton size="small" onClick={() => updateDirection(index)}>
            {inputResultIcon(column.label)}
          </IconButton>
        </Tooltip>
      </TableCell>
    );
  };
  
  const inputObjectsSortCompare = () => {
    return (obj1, obj2) => {
      let val1 = parseInt(obj1.data, 10);
      let val2 = parseInt(obj2.data, 10);
      return (val2 - val1);
    };
  };

  const inputObjectsOptions = { 
        sortCompare: inputObjectsSortCompare, 
        customHeadRender: inputObjectsHeadRender,
        setCellProps: () => ({ align: "right" }),
  };
  
  const columnDefs = [
    { name: 'EndTime', label: 'End Time', options: { filter:false, customBodyRender: fmtExecutionEndTime } },
    { name: 'Inputs.Selected.Objects', label: "Submitted",
      options: inputObjectsOptions
    },
    { name: 'Inputs.Skipped.Objects', label: "Skipped",
      options: inputObjectsOptions 
    },
    { name: 'Inputs.Failed.Objects', label: "Failed",
      options: inputObjectsOptions 
    },
    { name: 'Inputs.Succeeded.Objects', label: "Succeeded",
      options: inputObjectsOptions 
    },
  ];
  
  const inputResultOptions = [ 
    "SKIPPED", "FAILED", "SUCCEEDED"
  ];
  
  return (
    <form className={classes.root} noValidate autoComplete="off">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography color="textSecondary">
            Choose from previous completed executions...
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <ExecutionDataTable
            data={executions}
            columns={columnDefs}
            onRowSelectionChange={handleSelectedExecutionsChange}
            selectableRows="single"
            rowsPerPage={100}
            noHeader
            noFooter
          /> 
        </Grid>
        <Grid item xs={12}>
          <Autocomplete
            multiple
            id="tags-outlined"
            options={inputResultOptions}
            defaultValue={includeResultDefaults}
            onChange={handleIncludeResultChange}
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                label="Retry inputs from selected executions with..."
                placeholder="Result"
              />
            )}
          />
        </Grid>
      </Grid>
    </form>
  );
}

ChooseDataByExecutionStep.propTypes = {
  workloadId: PropTypes.string.isRequired,
  inputSelectors: PropTypes.array.isRequired,
  onInputSelectorsChange: PropTypes.func,
};

ChooseDataByExecutionStep.defaultProps = {
};


